// Testi italiani — l’ospite è sempre trattato con il „Lei“; sulle etichette dei
// pulsanti resta la forma breve d’uso comune nelle interfacce (Avanti, Indietro).
// Due forme di plurale (one | other), quelle che vue-i18n sceglie di serie.
export default {
    general: {
        back:     'Indietro',
        next:     'Avanti',
        cancel:   'Annulla',
        from:     'da',
        night:    'a notte',
        nights:   '{count} notte | {count} notti',
        loading:  'Caricamento …',
        language: 'Lingua',
        theme:    'Aspetto',
    },
    errors: {
        generic_error: 'Si è verificato un problema. Riprovi.',
        invalid_data:  'I dati inseriti non sono corretti.',
        not_found:     'Non trovato.',
        offline:       'Non riusciamo a contattare l’hotel. Controlli la connessione e riprovi.',
        no_house:      'Questa struttura al momento non accetta prenotazioni online.',
        taken:         'Questa camera è appena stata prenotata da qualcun altro. Ne scelga un’altra oppure cambi le date.',
        too_many:      'Troppi tentativi. Attenda un momento e riprovi.',
        too_many_guests: 'In questa camera non c’è posto per così tante persone.',
        booking_failed:  'Non è stato possibile effettuare la prenotazione.',
        offer_gone:      'L’offerta non è più valida. Sono mostrate le tariffe ordinarie della struttura.',
    },
    step: {
        dates:   'Date',
        rooms:   'Camera',
        guest:   'Dati',
        summary: 'Riepilogo',
        done:    'Confermata',
    },
    search: {
        title:          'Prenoti una camera',
        lead:           'Scelga le date e il numero di persone; Le mostreremo le camere disponibili e il prezzo.',
        arrival:        'Arrivo',
        departure:      'Partenza',
        adults:         'Adulti',
        children:       'Bambini',
        submit:         'Cerca camere disponibili',
        stay_too_long:  'Il soggiorno può durare al massimo {nights} notti.',
        departure_after: 'La partenza deve essere successiva all’arrivo.',
        arrival_past:   'L’arrivo non può essere nel passato.',
    },
    package: {
        title: 'Nel pacchetto',
        included: 'incluso',
        surcharges_total: 'Supplementi',
        kind_room_service: 'Servizio in camera',
        kind_dining: 'Pasto',
        kind_facility: 'Struttura',
        kind_parking: 'Parcheggio',
        kind_service: 'Servizio',
        kind_product: 'Prodotto',
        when_arrival: 'all\'arrivo',
        when_each_night: 'ogni notte',
        when_departure: 'alla partenza',
    },
    rooms: {
        component_gone: 'Una parte del pacchetto non è disponibile in queste date',
        component_gone_hint: 'Esaurito: {what}. Provate altre date — il pacchetto resta valido.',
        title:      'Camere disponibili',
        stay:       '{arrival} – {departure} · {nights} · {guests}',
        none:       'Per le date scelte non ci sono camere disponibili.',
        none_hint:  'Provi con altre date oppure con meno persone.',
        change:     'Cambia date',
        choose:     'Scegli',
        per_stay:   'per l’intero soggiorno',
        left:       'Ancora {count} camera disponibile | Ancora {count} camere disponibili',
        sleeps:     'Fino a {count} persona | Fino a {count} persone',
        beds:       '{count} letto | {count} letti',
        photo_of:   'Fotografia della camera {name}',
        offer_price: 'prezzo dell’offerta (−{percent}%)',
        early_booking:       'Prenota prima −{percent}%',
        early_booking_saved: 'risparmi {amount}',
        offer_applied: 'I prezzi qui sotto seguono questa offerta, ridotti del {percent}%.',
        offer_gone: 'L’offerta non è più valida',
        offer_gone_hint: 'La struttura l’ha ritirata o modificata, quindi qui sotto trova le tariffe ordinarie.',
    },
    board: {
        none:       'Solo pernottamento',
        breakfast:  'Pernottamento e prima colazione',
        half_board: 'Mezza pensione',
        full_board: 'Pensione completa',
        all_inclusive: 'All inclusive',
    },
    guest: {
        title:      'I Suoi dati',
        lead:       'Invieremo la conferma della prenotazione a questo indirizzo.',
        first_name: 'Nome',
        last_name:  'Cognome',
        email:      'Indirizzo e-mail',
        phone:      'Telefono',
        notes:      'Messaggio per l’hotel',
        notes_hint: 'Facoltativo — per esempio l’orario di arrivo o una richiesta particolare.',
        required:   'Questo campo è obbligatorio.',
        email_bad:  'Inserisca un indirizzo e-mail valido.',
        submit:     'Continua al riepilogo',
    },
    summary: {
        room_only: 'Alloggio',
        payment_optional: 'Può pagare ora con carta oppure all’arrivo, alla reception.',
        payment_deposit: 'Un acconto di {amount} ({percent} % del totale) conferma il soggiorno — ora oppure tramite il link contenuto nell’e-mail. Il saldo si versa all’arrivo, alla reception.',
        payment_full: 'L’importo totale di {amount} conferma il soggiorno — ora oppure tramite il link contenuto nell’e-mail.',
        title:     'Riepilogo',
        lead:      'Controlli i dati e confermi la prenotazione.',
        stay:      'Soggiorno',
        room:      'Camera',
        offer:     'Offerta',
        early_booking: 'Prenota prima',
        guests:    'Persone',
        contact:   'Contatti',
        city_tax:  'Tassa di soggiorno {amount} a persona per notte',
        total:     'Totale IVA inclusa',
        payment:   'Pagamento all’arrivo, alla reception.',
        cancellation: 'Cancellazione gratuita entro il {date}',
        terms:     'Condizioni generali',
        accept:    'Accetto le condizioni di prenotazione e la politica di cancellazione.',
        accept_required: 'Per prenotare è necessario accettare le condizioni.',
        submit:    'Conferma prenotazione',
        sending:   'Invio in corso …',
    },
    done: {
        payment_optional: 'Può pagare ora con carta oppure all’arrivo, alla reception.',
        payment_remainder: 'Il saldo di {amount} si versa all’arrivo, alla reception.',
        payment_required: 'Per completare il soggiorno paghi {amount}',
        payment_required_hint: 'La camera è prenotata e La attende. Può pagare ora oppure più tardi, dal link contenuto nell’e-mail di conferma.',
        payment_done: 'Pagamento ricevuto. Grazie!',
        pay_now: 'Paga {amount}',
        pay_later: 'Il link per il pagamento si trova anche nell’e-mail di conferma.',
        pay_failed: 'Non è stato possibile aprire la pagina di pagamento. Riprovi oppure utilizzi il link contenuto nell’e-mail.',
        title:      'La Sua prenotazione è confermata',
        number:     'Numero di prenotazione',
        keep:       'Conservi il numero — è così che La ritroviamo se ci chiama.',
        mail_sent:  'Abbiamo inviato la conferma a {email}.',
        mail_none:  'Non siamo riusciti a inviare la conferma via e-mail; sarà l’hotel a contattarLa.',
        payment:    'Pagamento all’arrivo, alla reception.',
        again:      'Nuova prenotazione',
    },
    occupancy: {
        adults:   '{count} adulto | {count} adulti',
        children: '{count} bambino | {count} bambini',
    },
    license: {
        title: 'Questo servizio non è attivo',
        lead: 'Questo hotel non ha attivato la prenotazione online, quindi da questa pagina non è possibile prenotare una camera.',
        contact: 'Chiami la reception dell’hotel: sarà lieta di effettuare la prenotazione per lei.',
    },
    closed: {
        title: 'Le prenotazioni non sono al momento possibili',
        lead:  'Questa struttura al momento non vende camere online. Chiami la reception: saranno lieti di aiutarLa.',
    },
}
